import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { FileText, Trash2, RefreshCw } from 'lucide-react';
import { format } from 'date-fns';

export default function Logs() {
  const api = useApi();
  const { can } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clearing, setClearing] = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    const d = await api.get('/logs');
    if (d) setLogs(d.logs || []);
    setLoading(false);
  }

  async function clearLogs() {
    if (!window.confirm('Saare logs delete karein? Yeh action wapas nahi ho sakta.')) return;
    setClearing(true);
    const d = await api.del('/logs');
    if (d?.success) { toast.success('Logs saaf ho gaye'); setLogs([]); }
    else toast.error('Error aaya');
    setClearing(false);
  }

  return (
    <div className="page">
      <div className="page-header" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div className="section-title">📋 Logs</div>
          <div className="section-sub">Bot ke system logs — akhri 100 entries</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-ghost btn-sm" onClick={load} disabled={loading}>
            <RefreshCw size={13} style={{ marginRight: 5, animation: loading ? 'spin 1s linear infinite' : 'none' }} />
            Refresh
          </button>
          {can('logs') && (
            <button className="btn btn-sm" onClick={clearLogs} disabled={clearing}
              style={{ background: '#3d1010', border: '1px solid #7a2020', color: '#f87171' }}>
              <Trash2 size={13} style={{ marginRight: 5 }} />
              {clearing ? 'Saaf ho raha...' : 'Clear Logs'}
            </button>
          )}
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <span className="spinner" style={{ width: 28, height: 28 }} />
          </div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>
            <FileText size={32} style={{ marginBottom: 10, opacity: 0.4 }} />
            <div style={{ fontSize: 13 }}>Koi log nahi mila</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'left', color: 'var(--text-muted)', fontWeight: 500, whiteSpace: 'nowrap' }}>#</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', color: 'var(--text-muted)', fontWeight: 500 }}>Message</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', color: 'var(--text-muted)', fontWeight: 500, whiteSpace: 'nowrap' }}>Waqt</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, i) => (
                  <tr key={log.id} style={{ borderBottom: '1px solid var(--border)', transition: 'background 0.1s' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-card-hover)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 16px', color: 'var(--text-muted)' }}>{i + 1}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--text-primary)', wordBreak: 'break-word', maxWidth: 500 }}>
                      {log.message || '—'}
                    </td>
                    <td style={{ padding: '10px 16px', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                      {log.created_at
                        ? format(new Date(log.created_at), 'dd MMM yyyy, hh:mm a')
                        : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
